<template>
  <div>
    <table-compnent
      :currentPage="1"
      :pageSize="10"
      :totalSize="51"
      :records="tableData"
      @resetHandler="reset"
      @searchHandler="doSearch"
      @addHandler="saveMenu"
      @queryByIdHandler="queryById"
      @deleteByIdHandler="deleteById"
      @batchDeleteHandler="batchDelete"
    >
      <template v-slot:search>
        <el-form-item label="菜单编号：">
          <el-input
            v-model="search.code"
            placeholder="请输入菜单编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="菜单名称:">
          <el-input
            v-model="search.name"
            placeholder="请输入菜单名称"
          ></el-input>
        </el-form-item>
      </template>
      <template v-slot:content>
        <el-table-column prop="id" label="序号"> </el-table-column>
        <el-table-column prop="code" label="菜单编号"></el-table-column>
        <el-table-column prop="name" label="菜单名称"></el-table-column>
        <el-table-column prop="pid" label="父ID"></el-table-column>
        <el-table-column prop="url" label="操作地址"></el-table-column>
        <el-table-column prop="remark" label="描述"></el-table-column>
      </template>
    </table-compnent>
  </div>
</template>

<script>
import TableCompnent from "@/components/table/TablesComponents";
import MenuApi from '@/api/MenuApi';
import { navTo,queryParam } from "@/utils/NavigatorUtils";
export default {
  name: "MenuList",
  props: {
    msg: String,
  },
  components: {
    TableCompnent,
  },
  data() {
    return {
      tableData:{},
      search: {
        code: "",
        name: "",
      },
      page:{}
    };
  },
  methods: {
    reset() {
      this.search = {};
    },
    doSearch(params) {
      this.page = params;
      this.search.pageSize = this.page.pageSize
      this.search.pageNum = this.page.pageNum
      MenuApi.search(this.search).then((resp)=>{
        if(resp.state=="OK"){
          this.tableData = resp.data
        }
      })
    },
    saveMenu(){
      navTo(this,"saveMenu")
    },

    queryById(id){
      MenuApi.queryMenuById(id).then((resp)=>{
        if(resp.state=="OK"){
          queryParam(this,"saveMenu",resp.data);
        }
      })
    },
    deleteById(id){
      MenuApi.deleteMenu(id).then((resp)=>{
        if(resp.state=="OK"){
          this.doSearch(this.page)
        }else{
          this.$errorMsg(resp.msg)
        }
      })
    },
    batchDelete(params){
      MenuApi.batchDeleteMenu(params).then((resp)=>{
        if(resp.state=="OK"){
          this.$successMsg(resp.msg)
          this.doSearch(this.page)
        }else{
          this.$errorMsg(resp.msg)
        }
      })
    }
  },
};
</script>